// Backend-backed "eligible departments" filter for ticket creation/assignment.
//
// A school with no saved rows means "no restriction, show all departments"
// (matches pre-existing behavior). Nothing here ever deletes a department,
// committee, or staff record — it's purely an allow-list the frontend uses
// to filter dropdown options.

import axios from "axios";

const API_URL = "https://topschool.prisms.in/rest/index.php/user_list.json?";

// Resolves to the saved list of eligible department names for this school,
// or null if none configured (or the request failed) — meaning: show everything.
export function fetchEligibleDepartments(sid) {
  return axios
    .post(API_URL, { fun_name: "GetEligibleDepartments", sid: sid }, { timeout: 20000 })
    .then(function (res) {
      var departments = res.data && Array.isArray(res.data.departments) ? res.data.departments : [];
      return departments.length > 0 ? departments : null;
    })
    .catch(function (err) {
      console.error("[departmentFilter] GetEligibleDepartments failed:", err);
      return null;
    });
}

// Resolves to true/false depending on whether the save succeeded.
export function saveEligibleDepartments(sid, list) {
  return axios
    .post(API_URL, { fun_name: "SaveEligibleDepartments", sid: sid, departments: JSON.stringify(list) }, { timeout: 20000 })
    .then(function (res) {
      return !!(res.data && res.data.success);
    })
    .catch(function (err) {
      console.error("[departmentFilter] SaveEligibleDepartments failed:", err);
      return false;
    });
}

// Filters a list of department/committee names down to the eligible ones.
// `eligible` is the (already-fetched) result of fetchEligibleDepartments —
// null/empty means no restriction, so the full list is returned unchanged.
export function filterDepartments(allDepartments, eligible) {
  if (!eligible || eligible.length === 0) return allDepartments;
  return allDepartments.filter(function (d) { return eligible.indexOf(d) !== -1; });
}
